import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Matt Stayner
 * id 500822ED-8EE6-427C-A4CE-AE56A4CB4C61
 * name arrow-top-right-thin
 * version: 6.5.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/arrow-top-right-thin.svg
 * tags
 * - Arrow 
 */
export const ArrowTopRightThinIcon = createSvgIcon(<><path d="M11.93 5L14.76 7.83L5 17.59L6.42 19L16.18 9.25L19 12.07V5H11.93Z" /></>, 'ArrowTopRightThinIcon');
export default ArrowTopRightThinIcon